import { render, staticRenderFns } from "./shoppingCar.vue?vue&type=template&id=04e09176&"
import script from "./shoppingCar.vue?vue&type=script&lang=js&"
export * from "./shoppingCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e09176')) {
      api.createRecord('04e09176', component.options)
    } else {
      api.reload('04e09176', component.options)
    }
    module.hot.accept("./shoppingCar.vue?vue&type=template&id=04e09176&", function () {
      api.rerender('04e09176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/shoppingCar.vue"
export default component.exports